import { DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE } from 'configs';

export type FilterType = {
  refreshData: number;
  pageSize: number;
  pageIndex: number;
};
export const getInitFilterValues = (urlParams: any): FilterType => {
  return {
    refreshData: 0,
    pageSize: Number(urlParams?.get('pageSize') ?? DEFAULT_PAGE_SIZE),
    pageIndex: Number(urlParams?.get('pageIndex') ?? DEFAULT_PAGE_INDEX),
  };
};
